export const statusContainerAreaName = 'status-container';
export const statusContainerBearingProp = 'statusId';
